import React from "react";
import { Route } from "react-router-dom";
import { CustomRoute } from "react-admin";

const ReactAdminCustomRoute = (props: CustomRoute) => <Route {...props} />;

export default ReactAdminCustomRoute;
